import React from 'react';
import { Link } from "react-router-dom";
import { is } from 'redux-saga/utils';
import { GRANT, REQUEST, REQUESTV2 } from '../../constants/textConstants';

class ProxyConfirmationStatus extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { userPharmacy, firstName, lastName, isMinor, selected, heading, status, requestType, manageOwnHealthcare, enableProxyRequestV2, useOnboardingLayout } = this.props;
        const statusClass = (status && status.toLowerCase() === "approved") ? "status-approved" : "status-pending";
        const statusIconClass = (status && status.toLowerCase() === "approved") ? "icon-check" : "icon-pending";
        
        return (requestType === REQUEST ?
           <div className="proxy-msg-container">
                <div className="proxy-msg__heading">{heading}</div>                
                    <> <div className={`proxy-msg__status ${statusClass}`}><span className={`${statusIconClass}`} /> {status}</div>
                    {selected === "healthRecordSelected" && <>
                        {enableProxyRequestV2 && manageOwnHealthcare && !isMinor 
                            ? <> <div className="proxy-msg__info">
                                    <p>{firstName}  {lastName} will receive an email notification to approve this request. You'll be notified of the response.</p>
                                </div>
                                <div className="proxy-msg__note">
                                    Note: He or she will have the right to terminate this request at any time without your approval. If {firstName} does not have a MyBSWHealth account, he or she will receive an email with instructions to activate an account.
                                </div>
                            </>
                            : <div className="proxy-msg__info">Please allow up to 2 hours for review and processing on business days from 8 AM - 5 PM. You will receive an email with the status of your request.</div>
                        }
                    </>
                    }
                    {!isMinor ?
                        <>  {(selected === "pharmacySelected") &&
                            <>
                                <div className="proxy-msg__info">
                                    <p>{firstName}  {lastName} will receive an email notification to approve this request. You'll be notified of the response.</p>
                                </div>
                                <div className="proxy-msg__note">
                                    Note: He or she will have the right to terminate this request at any time without your approval. If {firstName} does not have a MyBSWHealth account, he or she will receive an email with instructions to activate an account.
                                </div>
                            </>
                            }
                        </>
                        :
                        <> {(selected === "pharmacySelected") &&
                            <>
                                <div className="proxy-msg__info">You can now access {firstName}'s pharmacy account. </div>
                                {!useOnboardingLayout &&
                                    <div className="proxy-msg__btn">
                                        <Link to={{ pathname: "/pharmacy" }} onClick={() => this.props.switchToPharmacy(userPharmacy)}>View {firstName}'s Pharmacy account</Link>
                                    </div>
                                }
                            </>
                            }
                        </>
                    }
                    </>                
            </div> :
            <div className="proxy-msg-container">
                <div className="proxy-msg__heading">{heading}</div>
                <div className={`proxy-msg__status ${statusClass}`}><span className={`${statusIconClass}`} /> {status}</div>
                <div className="proxy-msg__info">
                    {requestType === REQUESTV2 && enableProxyRequestV2 ?
                        !manageOwnHealthcare && selected === "healthRecordSelected" ? 
                            <p>Please allow up to 1 business day for review and processing on business days from 8 AM - 5 PM. You will receive an email with the status of your request.</p>
                                :<p>{firstName} will receive an email notification to approve this request. You'll be notified of the response.</p>
                        : <p>{firstName} will receive an email request to approve this request and verify your relationship by entering your birthday.</p>
                    }
                </div>
                {requestType === REQUESTV2 && enableProxyRequestV2 && !manageOwnHealthcare && selected === "healthRecordSelected" ? "" :
                <div className="proxy-msg__note">
                    Note: He or she will have the right to terminate this request at any time without your approval. If {firstName} does not have a MyBSWHealth account, an email will be sent with instructions to activate an account.
                </div>
                }
            </div>
        );
    };
}

export default ProxyConfirmationStatus;